import { getResolvedRefDeep as e } from "@scalar/workspace-store/helpers/get-resolved-ref-deep";
import { getResolvedRef as t, mergeSiblingReferences as n } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { buildRequestBody as r, coerceLeafValueToSchemaType as i, getExample as a, getExampleFromBody as o, getExampleFromSchema as s, needsMultipartEncoding as c, resolveLeafSchema as l, serializeFormPropertyWithEncoding as u, serializeMultipartArray as d, serializeMultipartBody as f } from "@scalar/workspace-store/request-example";
import { isXmlMediaType as p } from "@scalar/helpers/http/is-xml-media-type";
import { getExampleValue as m, getExplicitExampleText as h } from "@scalar/workspace-store/helpers/get-example-value";
import { serializeStreamExample as g } from "@scalar/workspace-store/helpers/serialize-stream-example";
import { unpackProxyObject as _ } from "@scalar/workspace-store/helpers/unpack-proxy";
//#region src/code-example/helpers/operation-to-har/process-body.ts
var v = (e, t, n, r = !1, a) => {
	let o = [], s = Array.isArray(e) ? e.filter((e) => !e.isDisabled).map((e) => [String(e.name), e.value]) : Object.entries(e);
	for (let [c, f] of s) {
		if (f == null) continue;
		let s = n ? void 0 : t?.[c];
		if (r && !n) {
			let t = Array.isArray(e) ? i(f, l(a, [c])) : f, n = d(c, Array.isArray(t) ? t : f, s);
			if (n) {
				for (let e of n) o.push({
					name: e.key,
					value: e.value instanceof File ? `@${e.value.name}` : e.value,
					...e.contentType ? { contentType: e.contentType } : {}
				});
				continue;
			}
		}
		let p = s && (s.style !== void 0 || s.explode !== void 0 || s.allowReserved !== void 0), m = p || !r ? void 0 : s?.contentType, h = n ? null : u(c, f, s);
		if (h) for (let e of h) o.push({
			name: e.key,
			value: e.value
		});
		else if (f instanceof File) {
			let e = _(f);
			o.push({
				name: c,
				value: `@${e.name}`,
				...m ? { contentType: m } : {}
			});
		} else if (m && typeof f == "object") o.push({
			name: c,
			value: JSON.stringify(_(f)),
			contentType: m
		});
		else if (r && !n && !p && typeof f == "object" && !Array.isArray(f)) o.push({
			name: c,
			value: JSON.stringify(_(f)),
			contentType: "application/json"
		});
		else if (Array.isArray(f)) for (let e of f) if (e instanceof File) {
			let t = _(e);
			o.push({
				name: c,
				value: `@${t.name}`
			});
		} else o.push({
			name: c,
			value: String(e)
		});
		else if (typeof f == "object") {
			let e = v(f, void 0, c);
			for (let t of e) o.push({
				name: `${c}.${t.name}`,
				value: t.value
			});
		} else o.push({
			name: c,
			value: String(f),
			...m ? { contentType: m } : {}
		});
	}
	return o;
}, y = ({ requestBody: i, contentType: l, example: u, openapiVersion: d, requestBodyCompositionSelection: y }) => {
	let b = l || Object.keys(i.content)[0] || "", x = b === "other" ? "" : b, S = (e) => `@${_(e).name || "filename"}`, C = i.content[b]?.encoding, w = i.content[b];
	if (w && c(b, w)) {
		let e = u ?? Object.keys(w.examples ?? {})[0] ?? "default", t = r({
			...i,
			"x-scalar-selected-content-type": { [e]: b }
		}, e, y);
		if (t?.mode === "multipart") {
			let e = f(t.value, t.contentType);
			return {
				mimeType: e.contentType,
				text: e.chunks.map((e) => e instanceof File ? S(e) : e instanceof Blob ? "BINARY" : String(e)).join("")
			};
		}
	}
	let T = b === "multipart/form-data" || b === "application/x-www-form-urlencoded";
	if (p(b)) {
		let e = o(i, b, u ?? "", y, d);
		return e ? {
			mimeType: x,
			text: e.value
		} : void 0;
	}
	let E = m(a(i, u, l)), D = h(E, b);
	if (D !== void 0) return {
		mimeType: x,
		text: D
	};
	let O = E?.value;
	if (O !== void 0) {
		let e = typeof O == "object" && O ? _(O) : O;
		return T && typeof e == "object" && e ? {
			mimeType: x,
			params: v(e, C, void 0, b === "multipart/form-data", t(i.content[b]?.schema, n))
		} : e instanceof File ? {
			mimeType: x,
			text: S(e)
		} : {
			mimeType: x,
			text: typeof e == "string" ? e : g(e, b, !1) ?? JSON.stringify(e)
		};
	}
	let k = i.content[b], A = t(k?.schema ?? k?.itemSchema);
	if (A !== void 0) {
		let t = s(e(A), {
			compositionSelection: y,
			mode: "write"
		}, { schemaPath: ["requestBody"] });
		if (t !== void 0) return T && typeof t == "object" && t ? {
			mimeType: x,
			params: v(t, C, void 0, b === "multipart/form-data")
		} : {
			mimeType: x,
			text: g(t, b, k?.schema === void 0) ?? (typeof t == "string" ? t : JSON.stringify(t))
		};
	}
};
//#endregion
export { y as processBody };

//# sourceMappingURL=process-body.js.map